module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'controller',
        'controller',
    ],

    config: {
        showColorBar: true,
        tabConfigNavKey: 'scheduler',
        activeView: 'scheduler',
    },

    hooks: {
        updateFilters($element, options){
            this.find('templates_core_scheduler_scheduler', scheduler => {
                scheduler.updateFilters(options.params || {})
            })
        }
    }
}